import { useQuery } from "@tanstack/react-query"

import { getMissions } from "./api"
import { QUERY_KEYS } from "../../constants"
import { useUserQuery } from "../queries"

export const useMissionsQuery = () => {
  const { user } = useUserQuery()

  return useQuery({
    queryKey: [QUERY_KEYS.MISSIONS],
    queryFn: () => getMissions(user?.id!),
    enabled: !!user,
  })
}
